module.exports = __webpack_public_path__ + "static/media/speaker2026.be73d7f8.png";